export default {"src":"/_next/static/media/hsiyc-tac-horizontal-pos-cmyk.633a9d7b.svg","height":25,"width":276,"blurWidth":0,"blurHeight":0};